import { Block, Flex, Icon, Tooltip, Typography, theme } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-sui-chakra, aloft/prefer-sound-ui-button
import { Button } from '@aloft/toolkit-sui/chakra';

import { PropertyGridColumnDefinition } from '../../types.ts';
import { getDataSourceDisplayInfo, getSelectSourceTooltip } from '../../utils.ts';
// eslint-disable-next-line aloft/prefer-sound-ui-button
import { sharedButtonStyle } from '../styles.ts';
import { TruncatedText } from './TruncatedText.tsx';
import { SourceOption } from './types.ts';

type PopoverOptionRowProps = SourceOption & {
  propertyData?: PropertyGridColumnDefinition['propertyData'];
  onClick: () => void;
};

export const PopoverOptionRow = ({
  value,
  source,
  propertyData,
  onClick,
}: PopoverOptionRowProps) => (
  <Button
    key={source}
    title={value}
    backgroundColor={theme.colors.surface1}
    {...sharedButtonStyle}
    onClick={onClick}
  >
    <Flex alignItems="center" justifyContent="space-between" width="100%">
      <TruncatedText>
        <Typography variant="body1">{value}</Typography>
      </TruncatedText>
      <Tooltip label={getSelectSourceTooltip(source)}>
        <Icon icon={getDataSourceDisplayInfo(source, propertyData).icon} color="buttonDefault" />
      </Tooltip>
    </Flex>
  </Button>
);
